export const mobileQuery = 768